const hartuPageDataTransformer = data => {
    const filaNumber = '3'
    const columnNumber = '1'
    const pagetIntroData = data?.filas?.[filaNumber]?.columnas?.[columnNumber]?.contenido

    return pagetIntroData
}

export default hartuPageDataTransformer